export enum BusinessType {
    MortgageLender = 'B053507B-328F-EA11-86E9-000D3A328C22',
    RealEstate = '00C412CB-328F-EA11-86E9-000D3A328C22'
}

export enum PricingConfig {
    'OptimalBlue',
    'LenderPrice'
}